// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + {"302":"reads","461":"skills","597":"projects","657":"project-card","962":"home"}[chunkId] + "-" + {"302":"2a117177edbb9fc06de3","461":"bf5ba6c8e50ee1fd693c","597":"7af56212bb8df4ee4317","657":"d99655c9023495f790ea","962":"062504e66561f4a7f535"}[chunkId] + ".css";
};